// src/redux/reducers/genderReducer.js
import {
    FETCH_GENDERS_REQUEST,
    FETCH_GENDERS_SUCCESS,
    FETCH_GENDERS_FAILURE,
    SET_SELECTED_GENDER,
  } from "../types";
  
  const initialState = {
    loading: false,
    genderOptions: [],
    selectedGender: null,
    error: null,
  };
  
  
  const genderReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_GENDERS_REQUEST:
        return { ...state, loading: true };
      case FETCH_GENDERS_SUCCESS:
        return { ...state, loading: false, genderOptions: action.payload };
      case FETCH_GENDERS_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case SET_SELECTED_GENDER:
        return { ...state, selectedGender: action.payload };
      default:
        return state;
    }
  };
  
  export default genderReducer;
  